import { createContext, useContext, useState } from 'react';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);

  const addItem = (product, quantity, attributes, pricePerM, notes = '') => {
    setItems(prev => {
      const existing = prev.findIndex(i => i.product_id === product.id);
      if (existing >= 0) {
        const updated = [...prev];
        updated[existing] = { ...updated[existing], quantity, attributes, pricePerM, notes };
        return updated;
      }
      return [...prev, { product_id: product.id, product, quantity, attributes, pricePerM, notes }];
    });
  };

  const updateItem = (productId, changes) => {
    setItems(prev => prev.map(i => i.product_id === productId ? { ...i, ...changes } : i));
  };

  const removeItem = (productId) => {
    setItems(prev => prev.filter(i => i.product_id !== productId));
  };

  const clearCart = () => setItems([]);

  const total = items.reduce((sum, i) => {
    const line = i.product?.price_unit === 'per_case'
      ? i.quantity * i.pricePerM
      : (i.quantity / 1000) * i.pricePerM;
    return sum + line;
  }, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateItem, removeItem, clearCart, total }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
